/** Dispatched after a successful in-app functional capacity submit so nav gates refresh immediately. */
export const FC_SUBMITTED_EVENT = "fit2lift:fc-submitted";

export function notifyFunctionalCapacitySubmitted(): void {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(FC_SUBMITTED_EVENT));
  }
}
